import React, { useContext } from 'react';
import classNames from 'classnames';

import { I18nContext } from '@bingads-webui-react/i18n-context';
import { withControlErrorHandling, withUnvalidatedControlErrors } from '@bingads-webui-campaign-react/error-handling';
import { withCustomValidation, withError } from '@bingads-webui-react/validation';
import { ValidatedFinalUrl as InternalFinalUrl } from '@bingads-webui-campaign-react/validated-url-input';
import { andComp, propertyIs, entityIs } from '@bingads-webui-campaign-react/form-error';
import { ERROR_ENTITY } from '@bingads-webui-campaign-react/pmax-common';

const entityIsAssetGroup = entityIs(ERROR_ENTITY.AssetGroup);
const assetGroupFinalUrlsProp = andComp(entityIsAssetGroup, propertyIs('FinalUrls'));

// eslint-disable-next-line max-len
const ValidatedFinalUrl = withError(withControlErrorHandling(withUnvalidatedControlErrors(withCustomValidation(InternalFinalUrl), { filter: assetGroupFinalUrlsProp })));

export const FinalUrl = React.memo(({ ...rest }) => {
  const i18n = useContext(I18nContext);

  return (
    <div className={classNames('final-url-section')}>
      <ValidatedFinalUrl i18n={i18n} {...rest} />
    </div>
  );
});

